import {AxiosHelperPortal} from '../utility/helperFunctions';
import {BASE_URL_WEB} from '../utility/constants';

export const INVOICE_UPDATED_EVENT = 'coachfirst:invoice-updated';

const invoiceUrl = (path, companyId) => {
  const params = new URLSearchParams({companyId});
  return `${BASE_URL_WEB}${path}?${params.toString()}`;
};

export const getClientInvoices = companyId =>
  AxiosHelperPortal(invoiceUrl('invoices', companyId), 'get');

export const getClientInvoice = (invoiceId, companyId) =>
  AxiosHelperPortal(invoiceUrl(`invoices/${encodeURIComponent(invoiceId)}`, companyId), 'get');

export const payClientInvoiceWithSavedCard = (invoiceId, companyId, cardId) =>
  AxiosHelperPortal(
    invoiceUrl(`invoices/${encodeURIComponent(invoiceId)}/pay`, companyId),
    'post',
    {cardId}
  );

export const payClientInvoiceWithNonce = (invoiceId, companyId, nonce, saveCard = false) =>
  AxiosHelperPortal(
    invoiceUrl(`invoices/${encodeURIComponent(invoiceId)}/pay`, companyId),
    'post',
    {nonce, saveCard: Boolean(saveCard)}
  );

export const notifyInvoiceUpdated = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(INVOICE_UPDATED_EVENT));
  }
};

export const invoiceErrorMessage = (error, fallback = 'Something went wrong. Please try again.') =>
  error?.data?.message ||
  error?.data?.error ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;
